var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPadLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 29,
    width: 36,
    height: 19,
    rx: 4,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1646 9.49829C22.9774 7.68544 25.4362 6.66699 27.9999 6.66699C30.5637 6.66699 33.0224 7.68544 34.8353 9.49829C36.6481 11.3111 37.6666 13.7699 37.6666 16.3337V23.667H18.3333V16.3337C18.3333 13.7699 19.3517 11.3111 21.1646 9.49829ZM14.3333 23.667V16.3337C14.3333 12.709 15.7731 9.23286 18.3361 6.66987C20.8991 4.10687 24.3753 2.66699 27.9999 2.66699C31.6245 2.66699 35.1007 4.10687 37.6637 6.66987C40.2267 9.23286 41.6666 12.709 41.6666 16.3337V23.667H44.3333C48.0152 23.667 51 26.6518 51 30.3337V46.667C51 50.3489 48.0152 53.3337 44.3333 53.3337H11.6667C7.98477 53.3337 5 50.3489 5 46.667V30.3337C5 26.6518 7.98477 23.667 11.6667 23.667H14.3333ZM39.6666 27.667H16.3333H11.6667C10.1939 27.667 9 28.8609 9 30.3337V46.667C9 48.1398 10.1939 49.3337 11.6667 49.3337H44.3333C45.8061 49.3337 47 48.1398 47 46.667V30.3337C47 28.8609 45.8061 27.667 44.3333 27.667H39.6666Z",
    fill: "#740E81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8354 37.9203L20.4889 37.0154L21 38.6607L18.3268 39.5656L20.0172 41.9717L18.6609 43L16.9705 40.5733L15.3194 42.9383L14.0025 41.8895L15.6929 39.5656L13 38.599L13.5111 36.9537L16.1843 37.9203V35H17.8354V37.9203Z",
    fill: "#740E81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8354 37.9203L31.4889 37.0154L32 38.6607L29.3268 39.5656L31.0172 41.9717L29.6609 43L27.9705 40.5733L26.3194 42.9383L25.0025 41.8895L26.6929 39.5656L24 38.599L24.5111 36.9537L27.1843 37.9203V35H28.8354V37.9203Z",
    fill: "#740E81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8354 37.9203L42.4889 37.0154L43 38.6607L40.3268 39.5656L42.0172 41.9717L40.6609 43L38.9705 40.5733L37.3194 42.9383L36.0025 41.8895L37.6929 39.5656L35 38.599L35.5111 36.9537L38.1843 37.9203V35H39.8354V37.9203Z",
    fill: "#740E81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadLock);
export default __webpack_public_path__ + "static/media/icon-pad-lock.03f228b524578a71c1282818c3d78d50.svg";
export { ForwardRef as ReactComponent };